import { render } from "./AddNewAccountDialog.vue?vue&type=template&id=4783f3f6"
import script from "./AddNewAccountDialog.vue?vue&type=script&lang=js"
export * from "./AddNewAccountDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__